import { inject, Injectable } from "@angular/core";
import { ProtectedUrlResolver } from "@ubisolutions/base";
import { Observable } from "rxjs";
import { ProtectedAssetsService } from "@auth/services/protected-assets.service";

/**
 * Files behind authentication (indoor map images), fetched with the user's token.
 */
@Injectable()
export class CtProtectedUrlResolver implements ProtectedUrlResolver {
    private readonly protectedAssetsService = inject(ProtectedAssetsService);

    getProtectedUrl(uuid: string): Observable<string> {
        return this.protectedAssetsService.getProtectedUrl(uuid);
    }
}
